/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the proposal(quotes) which tracks the lifecycle of the proposal.
 */
export type QuoteStatusType = 'accepted' | 'approved' | 'inProgress' | 'pendingApproval' | 'rejected';

export const QuoteStatusType = {
    ACCEPTED: 'accepted' as QuoteStatusType,
    APPROVED: 'approved' as QuoteStatusType,
    IN_PROGRESS: 'inProgress' as QuoteStatusType,
    PENDING_APPROVAL: 'pendingApproval' as QuoteStatusType,
    REJECTED: 'rejected' as QuoteStatusType
};

